import axios from "axios";
import { ELLCommerce } from "./ellCommerce";
export class BaseService {
    constructor(ellCommerce, serviceName) {
        this.ellCommerce = ellCommerce;
        this.serviceName = serviceName;
    }
    get api() {
        let baseUrl = "";
        switch (this.serviceName) {
            case "cart": {
                baseUrl = this.ellCommerce.config.cartServiceUri;
                break;
            }
            case "customer": {
                baseUrl = this.ellCommerce.config.customerServiceUri;
                break;
            }
            case "order": {
                baseUrl = this.ellCommerce.config.orderServiceUri;
                break;
            }
            case "product": {
                baseUrl = this.ellCommerce.config.productServiceUri;
                break;
            }
            case "promotion": {
                baseUrl = this.ellCommerce.config.promotionServiceUri;
                break;
            }
        }
        if (!baseUrl.endsWith("/")) {
            baseUrl += "/";
        }
        return axios.create({
            baseURL: baseUrl,
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: this.ellCommerce.config.getTokenFunction(),
                "Accept-Language": navigator.language,
            },
        });
    }
    handleError(e) {
        var _a;
        if (((_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.status) !== 404) {
            console.error(e);
            throw e;
        }
    }
    getCountryISO2(countryISO2) {
        const iso2 = countryISO2 && countryISO2 !== ""
            ? countryISO2
            : this.ellCommerce.config.defaultCountryISO2;
        if (!iso2 || iso2 === "") {
            this.handleError(new Error("Country ISO2 code must be provided for this call."));
        }
        return iso2;
    }
    getApplicationId() {
        const applicationId = this.ellCommerce.config.applicationId;
        if (!applicationId || applicationId === "") {
            this.handleError(new Error("ApplicationId must be provided for this call."));
        }
        return applicationId;
    }
    pushGtagEvent(ev) {
        ELLCommerce.GTagService.pushEvent(ev);
    }
}
